import { tr } from 'mmfintech-commons'
import PromoCashback from '@images/promo/Cashback Slide.jpg'
import PromoFerrari from '@images/promo/Ferrari Giveaway.jpg'
import PromoAwards from '@images/promo/Sign In Awards.jpg'
import WestHamBanner from '@images/promo/West Ham - 2.jpg'

const promotionalSlides = [
  {
    id: 1,
    get card() {
      return (
        <div className='promo-slide promo-slide-ferrari'>
          <img
            src={PromoFerrari}
            alt={tr(
              'FRONTEND.SLIDES.FERRARI_812_GTS_ATELIER_GIVEAWAY_FOR_EVERY_500_TRANSACTION_GET_1_',
              'Ferrari 812 GTS ATELIER Giveaway - For every €500 transaction, get 1 ticket!'
            )}
            className='promo-image'
          />
        </div>
      )
    }
  },
  {
    id: 2,
    get card() {
      return (
        <div className='promo-slide promo-slide-cashback'>
          <img
            src={PromoCashback}
            alt={tr('FRONTEND.SLIDES.5_CASHBACK_ON_EVERY_TRANSACTION', '5% Cashback on every transaction')}
            className='promo-image'
          />
        </div>
      )
    }
  },
  {
    id: 3,
    get card() {
      return (
        <div className='promo-slide promo-slide-awards'>
          <img
            src={PromoAwards}
            alt={tr(
              'FRONTEND.SLIDES.WELCOME_TO_THE_KINGDOM_BANK_AWARD_WINNING_BANKING',
              'Welcome to The Kingdom Bank - Award winning banking'
            )}
            className='promo-image'
          />
        </div>
      )
    }
  },
  {
    id: 4,
    get card() {
      return (
        <div className='promo-slide promo-slide-westham'>
          <img
            src={WestHamBanner}
            alt={tr('FRONTEND.AUTH_LEFT_SECTION.WEST_HAM_UNITED_BANNER', 'West Ham United banner')}
            className='promo-image'
          />
        </div>
      )
    }
  }
]

export default promotionalSlides
